module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/facebook_icon-e13788fffc4b8b6087ca7eb5dfeab644.svg";